export const environment = {
  production: true,
  // baseURL: "https://mu-react-backend.herokuapp.com",
  baseURL: "https://apireact.mastersunion.org",
  // baseURL: "http://localhost:3000",
  // baseURL: "http://localhost:2001",
  // mentorKart:"https://app.mentorkart.com",    // courseRoasterUrl:"http://localhost:31350/api/std/"
};
